<template>
	<div v-click-outside="close" class="popover-menu">
		<div ref="popoverMenu">
			<slot name="menu-toggle" :toggle="toggle" :active="active">
				<div class="popover-menu-toggle" :class="{ active, isBlack }" @click.prevent="toggle">
					<span />
					<span />
					<span />
				</div>
			</slot>
		</div>
		<transition name="popup-slide">
			<div v-show="active" ref="popover" class="popover-menu-content">
				<slot :close="close" />
			</div>
		</transition>
	</div>
</template>

<script>
import { createPopper } from '@popperjs/core'

export default {
	name: 'PopoverMenu',
	props: {
		appendToBody: {
			type: Boolean,
			default: false
		},
		placement: {
			type: String,
			default: ''
		},
		isBlack: {
			type: Boolean,
			default: false
		}
	},
	data: () => ({ active: false, placementStyles: null, component: null }),
	methods: {
		open () {
			let reference, popover
			if (!this.appendToBody) {
				reference = this.$refs.popoverMenu
				popover = this.$refs.popover
			} else {
				this.component = document.createElement('div')
				this.component.classList = 'body-popup'
				this.component.append(this.$refs.popover)
				document.body.append(this.component)
				this.component.style.cssText = 'position:absolute;min-width:50px; min-height:50px;z-index:1000;width:max-content'
				reference = this.$refs.popoverMenu
				popover = this.component
			}
			this.active = true
			// https://popper.js.org/docs/v2/constructors/  list of placements which supported
			createPopper(reference, popover, {
				placement: this.placement || 'auto-start'
			})
		},
		close (event) {
			if (event && this.appendToBody) {
				const path = event.path || (event.composedPath && event.composedPath())

				if (path.includes(this.$refs.popover)) {
					return false
				}
			}
			this.active = false
			this.appendToBody && this.component?.remove()
		},
		toggle () {
			this.active ? this.close() : this.open()
		}
	}
}
</script>

<style lang="scss">
	.popover-menu {
		position: relative;

		.popover-menu-toggle {
			margin-left: 10px;
			cursor: pointer;
			display: flex;
			flex-direction: column;
			&.active {
				span {
					&:nth-child(1) {
						transform: translateY(5px) rotate(-45deg);
					}

					&:nth-child(2) {
						opacity: 0;
					}

					&:nth-child(3) {
						transform: translateY(-5px) rotate(45deg);
					}
				}
			}
			&.isBlack {
				span {
					background-color: rgba(29, 29, 29, 0.9);
				}
			}
			span {
				display: inline-block;
				height: 3px;
				width: 14px;
				margin: 1px 0;
				border-radius: 10px;
				background-color: $white;
				transition: 0.2s transform;
				transform: rotate(0);
			}
		}

		.popover-menu-content {
			position: absolute;
			z-index: 100;
			top: 100%;
			right: 0;
			min-height: 50px;
			min-width: 100px;
			padding: 12px 6px 12px 16px;
			border-radius: 11px;
			-webkit-backdrop-filter: blur(10px);
			backdrop-filter: blur(10px);
			box-shadow: -1px 2px 6px 0 rgba(0, 0, 0, 0.59);
			background-color: rgba(42, 42, 42, 0.6);
			color: $white;
		}
	}
</style>
